import {
  ContentIsland,
  GraphicsCheckImage,
  Grid,
  ListContentIsland,
  Stack,
  Typography,
} from '@razz-team/ui-web';
import { TransactionListItem } from '../Transaction/Transaction';
import { ApiTransaction } from '../../openapi';
import { TransactionStatementListItem } from '../ListItem/TransactionStatementListItem';
import { useTranslation } from 'react-i18next';

export function TransferComplete({ transaction }: { transaction: ApiTransaction }) {
  const { t } = useTranslation();

  return (
    <Stack spacing={4}>
      <ContentIsland>
        <Grid container alignItems="center" spacing={2}>
          {__BRIGHTY__ ? (
            <Grid size={6}>
              <GraphicsCheckImage width="100%" />
            </Grid>
          ) : null}
          <Grid size={6}>
            <Typography variant="h4">{t('Transfer Complete')}</Typography>
          </Grid>
        </Grid>
      </ContentIsland>
      <ListContentIsland>
        <TransactionListItem transaction={transaction} />
        <TransactionStatementListItem
          transactionId={transaction.id}
          createdAt={transaction.date.created}
        />
      </ListContentIsland>
    </Stack>
  );
}
